import React, { useContext, useEffect, useState } from 'react'
import AnalyticsSnippet from './AnalyticsSnippet'
import SettingsStore from '../../flux/settings/SettingsStore'
import { Consent } from '../../common/Enums'
import { AppContext } from '../../context/AppContext'

/**
 * Determines whether or not to execute
 * the Microsoft Clarity snippet based on cookie consent
 */
function ControlAnalytics() {
    const settingsStore = SettingsStore.GetInstance()
    const { HasAnalyticsRendered, setHasAnalyticsRendered } = useContext(
        AppContext
    )
    const [cookieConsent, setCookieConsent] = useState(
        settingsStore.CookieConsent
    )

    useEffect(() => {
        /**
         * Handles the settings store change event
         */
        function handleSettingsChange() {
            setCookieConsent(settingsStore.CookieConsent)
        }

        settingsStore.addChangeListener(handleSettingsChange)

        if (!HasAnalyticsRendered && cookieConsent === Consent.Accepted) {
            AnalyticsSnippet()
            setHasAnalyticsRendered(true)
        }
        return () => {
            settingsStore.removeChangeListener(handleSettingsChange)
        }
    }, [
        HasAnalyticsRendered,
        cookieConsent,
        setHasAnalyticsRendered,
        settingsStore,
    ])

    return <></>
}

export default ControlAnalytics
